<template>
  <v-layout align-space-around justify-center row fill-height>
    <v-flex>
      <v-container fluid grid-list-xs>
        <v-layout>
          <v-flex xs12 class="text-xs-center">
            <span>Hrana vzadu</span>
            <br />
            <span>(Dĺžka)</span>
            <v-icon v-show="arrowBack" color="error">arrow_downward</v-icon>
          </v-flex>
        </v-layout>
        <v-layout align-center justify-center>
          <v-flex xs2 class="text-xs-center">
            Hrana vľavo
            <br />
            <span>(Šírka)</span>
            <v-icon v-show="arrowLeft" color="error">arrow_forward</v-icon>
          </v-flex>
          <v-flex xs8>
            <v-card dark color="secondary" class="elevation-9">
              <v-img :src="image" aspect-ratio="3" min-height="120"></v-img>
            </v-card>
          </v-flex>
          <v-flex xs2 class="text-xs-center">
            Hrana vpravo
            <br />
            <span>(Šírka)</span>
            <v-icon v-show="arrowRight" color="error">arrow_back</v-icon>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 class="text-xs-center">
            Hrana vpredu
            <br />
            <span>(Dĺžka)</span>
            <v-icon v-show="arrowFront" color="error">arrow_upward</v-icon>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import images from "@/views/cutting/js/images";
export default {
  name: "CuttingImage",
  props: ["material", "edge"],
  components: {},
  data() {
    return {
      images: images
    };
  },
  computed: {
    arrowFront() {
      if (this.edge.front == null) {
        return false;
      } else {
        return true;
      }
    },
    arrowBack() {
      if (this.edge.back == null) {
        return false;
      } else {
        return true;
      }
    },
    arrowLeft() {
      if (this.edge.left == null) {
        return false;
      } else {
        return true;
      }
    },
    arrowRight() {
      if (this.edge.right == null) {
        return false;
      } else {
        return true;
      }
    },
    image() {
      if (this.material == null) {
        return require("@/assets/woodmaterial.jpeg");
      }

      return this.images.demosImageUrl(this.material);
    }
  }
};
</script>

<style>
</style>